export default __webpack_public_path__ + "static/media/bg-light.215dfce3.jpg";